import { ROOT_SERVER_URL } from '../config';
import { request } from '../utils';

export type MarketVenueFormValues = {
  countryCode: string;
  exchangeName: string;
  mic: string;
  timezone: string;
};

export type MarketVenueRow = MarketVenueFormValues & {
  id: string;
  feeds?: Array<{ id: string; name: string }>;
};

export function getVenues(): Promise<MarketVenueRow[]> {
  return request(`${ROOT_SERVER_URL}/api/venues`);
}

export function addVenue(data: MarketVenueFormValues): Promise<MarketVenueRow> {
  return request(`${ROOT_SERVER_URL}/api/venues`, {
    data,
    method: 'POST',
  });
}

export function updateVenue(venueId: string, data: Partial<MarketVenueFormValues>): Promise<MarketVenueRow> {
  return request(`${ROOT_SERVER_URL}/api/venues/${venueId}`, {
    data,
    method: 'PUT',
  });
}

export function deleteVenue(venueId: string): Promise<void> {
  return request(`${ROOT_SERVER_URL}/api/venues/${venueId}`, {
    method: 'DELETE',
  });
}
